module.exports = __webpack_public_path__ + "img/notice.26ca043f.jpg";